/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { argKey } from 'solis/navigation';

import Args from 'solis/claude/action/args';

import ZoneRuleType from 'solis/claude/action/enum/zone.rule.type';


// cpp update_colony_zone_rule_args minus `source_user`.
const buildArgs = ({ colony, zone, args }) =>
{
  const payload = {};

  payload.galaxy = colony.cass.galaxy;
  payload.target_colony = colony.cass.id;
  payload.target_zone = zone.getAbsoluteHex().toString();

  payload.type = args.ruleType;
  payload.value = args.ruleValue;

  return payload;
};


// Every precondition is handled upstream: availability gates on the target zone, colony
// ownership and attachment, and the value slider is structurally bounded to a non-negative
// integer.
const validate = () =>
{
  return { valid: true, issues: [] };
};


const isAvailable = ({ colony, zone, account }) =>
{
  return zone !== null && !colony.cass.board && colony.cass.user === account.cass.id && zone.getSector().cass.user !== account.cass.id;
};


export default
{
  type: 'solis/colony/zone/rule/update',
  scope: argKey(Args.ColonyZone, 'updateRule'),
  inputs: { ruleType: ZoneRuleType.Incentive, ruleValue: 1 },

  isAvailable,
  buildArgs,
  validate,
};
